export const noFlight = [1, 4, 19, 25];
export const withFlight = [2, 16];
export const withHarbours = [6, 34];
export const withBus = [4, 25, 30, 35];
export const busHolidayTypeList = [4, 25, 26, 30, 35];
export const tourHolidayTypeList = [11, 16, 21, 24, 25, 26, 28, 30, 32, 33, 35, 48];
export const ALL_HOLIDAY_TYPES = [1, 2, 3, 4, 11, 16, 21, 24, 25, 26, 28, 30, 32, 33, 35];
export const hideTranferIncludedLabel = ['009619', '009622'];

export default {
  noFlight,
  withFlight,
  withHarbours,
  withBus,
  busHolidayTypeList,
  tourHolidayTypeList,
  hideTranferIncludedLabel
};
